import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Subject, Observable, BehaviorSubject, firstValueFrom } from 'rxjs';
import { HttpService } from 'src/app/shared/services/http/http.service';
import { apiConstants } from 'src/app/shared/constants/endpoints';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  userName = new Subject<string | null>();
  loaded: Subject<void> = new Subject<void>();
  permissions = new BehaviorSubject<any>([]);
  permissions$: Observable<any> = this.permissions.asObservable();
  private loggingInProgress: boolean = false;

  constructor(
    private router: Router,
    private jwtHelper: JwtHelperService,
    private httpService: HttpService,
  ) { }

  async checkAuth(name: string, email: string, token: string, redirect: boolean) {
    this.userName.next(name);
    localStorage.setItem('userName', name);
    localStorage.setItem('email', email);
    localStorage.setItem('id_token', token);
    this.getUserPermissions();
    const hasAlreadyLogged = localStorage.getItem('hasAlreadyLogged');
    if (!hasAlreadyLogged && !this.loggingInProgress) {
      this.loggingInProgress = true;
      try {
        await firstValueFrom(this.httpService.post(apiConstants.saveUserLoginLog, {
          userEmail: email,
          userName: name,
          status: '',
          loggedInDate: new Date(),
          errorMessage: ''
        }));
        localStorage.setItem('hasAlreadyLogged', 'true');
      } catch (err) {
        console.error('Failed to log login:', err);
      } finally {
        this.loggingInProgress = false;
      }
    }
    if('routeURL' in localStorage){
      const route = localStorage.getItem('routeURL');
      if (route && route.startsWith('/') && !route.startsWith('//') && !route.includes('http') && !route.includes('..'))
      {
        this.router.navigateByUrl(route);
        localStorage.removeItem('routeURL');
      }
    }      
    else if(redirect) this.router.navigateByUrl('dashboard');
  }

  getUserPermissions() {
    this.httpService.get(apiConstants.getUserPermissions).subscribe((user: any) => {
      if (user && user.userPermission && user.userPermission.length > 0) {
        const permissionsList = user.userPermission.map((permList: any) => permList.permission.name);
        this.permissions.next(permissionsList);
      }else {
          this.permissions.next([]);
          this.router.navigate(['/access-denied?title=site']);
      }
    })
  }

  /*hasPermission(authGroup: string []) {
    return !!(this.permissions && this.permissions.find((permission: any) => {
      return authGroup.includes(permission);
    }));
  }*/

}
